 <template>
     <div class="container consumer-review-widget">
         <div id="mask" :v-show="this.mask"></div>
         <reviews-summary
                 :totalReviewCount="reviewsSummary.TotalReviewCountGeneral"
                 :totalReviewCountApproved="reviewsSummary.TotalReviewCountApproved"
                 :totalReviewCountPending="reviewsSummary.TotalReviewCountPending"
                 :totalReviewCountRejected="reviewsSummary.TotalReviewCountRejected"
                 :averageOverallRating="reviewsSummary.AverageOverallRating"
                 :advertiser="advertiser"
                 :vertical="vertical"></reviews-summary>
         <div class="container-fuild filters">
             <div class="filter-row">
                 <div class="container">
                     <div class="col-md-6 col-sm-6 p-l-none">
                         <div class="input-group">
                             <input type="text" id="search" class="form-control" placeholder="Search"
                                    v-on:keyup.13="filteredSearch" v-on:click="clearParentError" v-model="titleSearch">
                             <div id="clearSearchDiv" class="input-group-btn" v-show="titleSearch && titleSearch.length > 0">
                                 <span v-on:click="clearTitleSearch">clear</span>
                             </div>
                             <span class="input-group-btn">
                            <button id="search-action" v-on:click="filteredSearch" class="btn btn-default btn-search">
                                <i class="fa fa-search"></i>
                            </button>
                        </span>
                         </div>
                     </div>
                     <div class="col-md-3 col-sm-3">
                        <date-range-picker :startDate="dateSearch.startDate" :endDate="dateSearch.endDate" v-on:update="dateSearchChange"></date-range-picker>
                     </div>
                     <div class="col-md-3 col-sm-3 p-r-none">
                         <multiselect
                             v-model="filterValue"
                             :options="filterOptions"
                             placeholder="Filter By"
                             :multiple="false"
                             :close-on-select="true"
                             :searchable="true"
                             selectLabel=""
                             deselectLabel=""
                             track-by="val"
                             label="label"
                             @input="filterChanged"
                         >
                         </multiselect>
                     </div>
                 </div>
             </div>
         </div>
         <div class="container-fuild arrow-box">
             <div class="arrowDiv" title="Open/Close Analytics"
                  aria-expanded="false" aria-controls="analytics" v-on:click="analyticsOpen=(!analyticsOpen)">
                 <span class="arrow up material-icons" v-if="analyticsOpen">&#xE316;</span>
                 <span class="arrow down material-icons" v-if="!analyticsOpen">&#xE313;</span>
             </div>
         </div>
         <reviews-analytics
                 v-if="analyticsOpen"
                 :advertiserUrl="frData.AdvertiserUrl"
                 :advertiserImageUrl="frData.AdvertiserImageUrl"
                 :totalReviewCountFiltered="frSummary.TotalReviewCountFiltered"
                 :totalReviewCountApproved="frSummary.TotalReviewCountApproved"
                 :totalReviewCountPending="frSummary.TotalReviewCountPending"
                 :totalReviewCountRejected="frSummary.TotalReviewCountRejected"
                 :averageOverallRating="frSummary.AverageOverallRating"
                 :fiveStarCount="frSummary.FiveStarCount"
                 :fourStarCount="frSummary.FourStarCount"
                 :threeStarCount="frSummary.ThreeStarCount"
                 :twoStarCount="frSummary.TwoStarCount"
                 :oneStarCount="frSummary.OneStarCount"
                 :percentageRecommendLender="frSummary.PercentageRecommendLender"
                 :averageProfessionalism="frSummary.AverageProfessionalism"
                 :averageKnowledge="frSummary.AverageKnowledge"
                 :averageResponsivness="frSummary.AverageResponsivness"
                 :averageLevelOfService="frSummary.AverageLevelOfService"
                 :percentageRatesHonored="frSummary.PercentageRatesHonored"></reviews-analytics>
         <div class="container">
             <div id="reviews-container">
                 <consumer-review :review="review" v-for="review in reviewsPaginated" :key="review.id"></consumer-review>
                 <div class="no-results text-center" v-show="reviews.length === 0" v-cloak>
                     No reviews found.<br>
                     Trying using a different search term.
                 </div>
             </div>
         </div>
         <pagination :pageCount="pageCountTotal"
                     :currentPage="currentPage"
                     :callback="pageCallback"></pagination>
     </div>
</template>

<script>
import ConsumerReview from "./review.vue";
import Multiselect from 'vue-multiselect';

export default {
    components: {
        ConsumerReview,
        Multiselect,
    },
    name: "ConsumerReviews",
    computed: {
        pageCount: function () {
            var pageCount = this.frSummary.TotalReviewCountFiltered / this.perPage;
            return Math.ceil(pageCount);
        },

        pageCountTotal: function () {
            return Math.ceil(this.reviews.length / this.perPage);
        },

        reviewsPaginated: function () {
            const index = this.currentPage - 1
            const start = index * this.perPage
            const end = start + this.perPage

            return this.reviews.slice(start, end);
        }
    },
    props: {
        vertical: {
            type: String,
            required: true
        },
        advertiser: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            analyticsOpen: false,
            filterOptions: [
                { val:'all',label:'All Reviews' },
                { val:'pending',label:'Pending Reviews' },
                { val:'approved',label:'Approved Reviews' },
                { val:'rejected',label:'Rejected Reviews' },
                { val:'5',label:'5 star Reviews' },
                { val:'4',label:'4 star Reviews' },
                { val:'3',label:'3 star Reviews' },
                { val:'2',label:'2 star Reviews' },
                { val:'1',label:'1 star Reviews' },
            ],
            endpointUrl: "https://aws.qa.bankrate.com/reviews",
            perPage: 10,
            currentPage: 1,
            titleSearch: '',
            dateSearch: {
                startDate: moment().subtract(3, 'months'),
                endDate: moment(),
            },
            filterValue: { val:'all', label:'All Reviews' },
            paginate: ["pagedReviews"],
            mask: false,
            loading: false,
            advertiserId: 0,
            reviews: [],
            reviewsSummary: {
                AverageOverallRating: 0,
                TotalReviewCount: 0,
                TotalReviewCountGeneral: 0,
                TotalReviewCountApproved: 0,
                TotalReviewCountPending: 0,
                TotalReviewCountRejected: 0
            },
            frData: {
                AdvertiserUrl: null,
                AdvertiserImageUrl: null
            },
            frSummary: {
                AverageOverallRating: 0,
                FiveStarCount: null,
                FourStarCount: null,
                ThreeStarCount: null,
                TwoStarCount: null,
                OneStarCount: null,
                PercentageRecommendLender: null,
                AverageProfessionalism: null,
                AverageKnowledge: null,
                AverageResponsivness: null,
                AverageLevelOfService: null,
                PercentageRatesHonored: null,
                TotalReviewCountFiltered: 0,
                TotalReviewCountApproved: 0,
                TotalReviewCountPending: 0,
                TotalReviewCountRejected: 0
            },
            moderatorCodes: {},
            lastAction: "all",
            query: {
                title: "",
                star: "",
                "date-range": ""
            },
            status: "all",
            dateRange: {
                start: new Date(2014, 0, 1),
                end: new Date(2014, 11, 31)
            },
            reviewsLoaded: false,
        };
    },
    methods: {
        setPageData: function(data, fromIndex = false) {
            if (
                data &&
                data.Container &&
                data.Container.Reviews &&
                typeof data.Container.Reviews === "object"
            ) {
                this.reviews = data.Container.Reviews;
                if (!this.reviewsLoaded) {
                    this.reviewsSummary = data.Container.allReviewsSummary;
                }

                this.frSummary = data.Container.filteredSummary;
                this.reviewsLoaded = true;

                this.frData = data.Container;
            } else {
                this.showToastrNotification(
                    "error",
                    "Failed to retrieve requested reviews!",
                    true
                );
                this.mask = false;
            }
        },
        indexSearch: function() {
            this.$http
                .get(route("api.tools.reviews.index"), {
                    params: {
                        type: "all",
                        perPage: this.perPage,
                        page: this.currentPage
                    }
                })
                .then(data => {
                    return data.json();
                })
                .catch(e => console.error(e.message))
                .then(data => { this.setPageData(data, true); });
        },
        filteredSearch: function() {
            const data = {
                titleSearch: this.titleSearch,
                filterSearch: this.filterValue && this.filterValue.val ? this.filterValue.val : 'all',
                perPage: 10,
                startDate: this.dateSearch.startDate.format('MM-DD-YYYY'),
                endDate: this.dateSearch.endDate.format('MM-DD-YYYY'),
                page: this.currentPage,
                vertical: this.vertical,
            };

            const queryString = this.reviewsLoaded ? '' : '?includeTotalSummary=true';
            this.$http
                .post(route('api.tools.reviews.search.post') + queryString, data).then(data => {
                    this.currentPage = 1;
                    this.setPageData(data.body, false)
                }, e => console.error(e.message)
            )
        },
        filterChanged: function(filterVal) {
            if(filterVal) this.filterValue = filterVal;
            this.filteredSearch();
        },
        pageCallback: function(pageNumber) {
            this.currentPage = pageNumber;
        },
        clearParentError: function(e) {
            $(e.target)
                .parent(".input-group")
                .removeClass("hasError");
        },
        dateSearchChange: function(dateStart, dateEnd, frequency) {
            this.dateSearch = {
                startDate: moment(dateStart),
                endDate: moment(dateEnd)
            };
            this.filteredSearch();
        },

        clearTitleSearch: function() {
            this.titleSearch = '';
            this.filteredSearch();
        },

        /* Message Handling */

        showErrorMessage: function(text) {
            text = text || "Something went wrong!";
            sweetAlert.fire("Oops...", text, "error");
        },

        showToastrNotification: function(type, text, allowClose) {
            sweetAlert.fire("Alert!", text, type);
        }
    },
    created: function() {
        this.filteredSearch();
    }
};
</script>

 <style>
 .dateRangePicker-input.form-control {
     width: 240px !important;
 }

 .consumer-review-widget, .consumer-review-widget .container {
     max-width: 1020px !important;
     padding-left: 0 !important;
     padding-right: 0 !important;
 }

 .consumer-review-widget .multiselect__tags {
     border-radius: 5px;
     padding-top: 4px;
     min-height: 41px;
     margin-top: 2px;
 }

 .consumer-review-widget .multiselect__select {
     height: 39px;
 }
 </style>
